namespace GeniuzPOS.InitialData {
    export namespace PsCustomerSurveyPosService {
        export const baseUrl = 'InitialData/PsCustomerSurveyPos';

        export declare function Create(request: Serenity.SaveRequest<PsCustomerSurveyPosRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsCustomerSurveyPosRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsCustomerSurveyPosRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsCustomerSurveyPosRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsCustomerSurveyPos/Create",
            Update = "InitialData/PsCustomerSurveyPos/Update",
            Delete = "InitialData/PsCustomerSurveyPos/Delete",
            Retrieve = "InitialData/PsCustomerSurveyPos/Retrieve",
            List = "InitialData/PsCustomerSurveyPos/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsCustomerSurveyPosService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
